// extracted by mini-css-extract-plugin
export var backdropBlur = "_mj-0";
export var contentCard = "_mj-5";
export var frame = "_mj-2";
export var image = "_mj-4";
export var imagePane = "_mj-3";
export var modal = "_mj-1";